import { router } from "@inertiajs/react"
import { Ellipsis, LogOut } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

// The onboarding flows' escape hatch, shared by the client wizard and the
// partner wizard (which pass their own session paths). Desktop keeps the quiet
// fixed Log out button in the bottom-left; on a phone that button sat on top of
// the step content, so below `md` it becomes a "…" menu in the top-right —
// absolute (not fixed) inside the shell, so it scrolls away with the page.
// The shell mounting this must be `relative`.
export function OnboardingLogout({ sessionPath }: { sessionPath: string }) {
  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => router.delete(sessionPath)}
        className="text-muted-foreground fixed bottom-5 left-5 z-10 hidden md:inline-flex"
      >
        <LogOut className="size-3.5" />
        Log out
      </Button>

      <div className="absolute top-4 right-4 z-10 md:hidden">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="text-muted-foreground"
              aria-label="Account menu"
            >
              <Ellipsis className="size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => router.delete(sessionPath)}>
              <LogOut className="size-3.5" />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  )
}
